import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
const pageContentVariants = cva('container flex flex-col mb-8', {
  variants: {
    variant: {
      default: 'mt-6 mb-8',
      'with-breadcrumb': 'mt-20 sm:mt-19'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
interface PageContentProps extends React.ComponentProps<'div'> {
  as?: React.ElementType;
  variant?: VariantProps<typeof pageContentVariants>['variant'];
}
function PageContent(t0) {
  const $ = _c(14);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      as: t1,
      variant: t2,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const Element = t1 === undefined ? "div" : t1;
  const variant = t2 === undefined ? "default" : t2;
  let t3;
  if ($[6] !== className || $[7] !== variant) {
    t3 = cn(pageContentVariants({
      variant
    }), className);
    $[6] = className;
    $[7] = variant;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== Element || $[10] !== children || $[11] !== props || $[12] !== t3) {
    t4 = <Element className={t3} {...props}>{children}</Element>;
    $[9] = Element;
    $[10] = children;
    $[11] = props;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
export { PageContent };